<div class="asset-search">
	<div class="search-input">
		<input type="text" class="padding-left-5" [placeholder]="[placeholder]" [formControl]="searchFormControl" (blur)="triggerAnalytics()" />
		<icon type="search" class="icon"></icon>
	</div>
</div>
